<template lang="pug">
    section
      b-container
        h1 CORPORATE CUSTOMER
        .breadcrumbs.text-muted.small.py-3
          b-button.btn-dark(:to="{name: 'Customers'}")
            font-awesome-icon.mr-2(icon="caret-left")
            span ALL CUSTOMERS
        b-card
          b-container
            .row
              .col-md-8.pb-2
                div
                  content-loader(:height="7", v-if="alert.loading")
                  form.mt-3(v-else-if="accountInputForm", @submit.prevent='onSubmit')
                    .row
                      .col-md-6
                        b-form-group
                          label FIRST NAME
                          b-form-input(name='firstname', type='text', v-model='accountInputForm.firstname', required='',  autocomplete="fname")
                      .col-md-6
                        b-form-group
                          label LAST NAME
                          b-form-input(name='lastname', type='text', v-model='accountInputForm.lastname', required='',  autocomplete="lname")
                      .col-md-12
                        b-form-group
                          label COMPANY NAME
                          b-form-input(name='company_name', type='text', v-model='accountInputForm.company_name', required='',  autocomplete="")
                      .col-md-6
                        b-form-group
                          label PHONE
                          b-form-input(type='tel', v-model='accountInputForm.phone', required='', pattern="\\d{10}", title='10 Digits only. No +27 or spaces please :)',  autocomplete="tel")
                      .col-md-6
                        b-form-group
                          label EMAIL
                          b-form-input(type='email', v-model='accountInputForm.email', required='',  autocomplete="email")
                    .row
                      .col-md-12
                        b-form-group
                          label STREET ADDRESS
                          b-form-input(type='text', maxlength="60", v-model='addressInputForm.line_1', required='', placeholder='Street', autocomplete="address-line1")
                      .col-md-12
                        b-form-group
                          label.d-inline BUILDING
                          b-form-input(type='text', minlength="5", maxlength="60", v-model='addressInputForm.line_2', placeholder='Building name and unit if applicable', autocomplete="address-line2")
                      .col-md-6
                        b-form-group
                          label CITY
                          b-form-input(type='text', maxlength="60", v-model='addressInputForm.city', required='')
                      .col-md-6
                        b-form-group
                          label PROVINCE
                          b-form-select(:options="provinces", v-model='addressInputForm.province', required='')
                      .col-md-6
                        b-form-group
                          label ZIP
                          b-form-input(type='number', v-model='addressInputForm.zip', required='', @keyup="preselectSuburb", autocomplete="shipping postal-code")
                      .col-md-6
                        b-form-group
                          label.d-inline SUBURB
                          small.d-inline.ml-2 (Enter ZIP to find suburbs)
                          b-form-select(:options="suburbs", v-model='addressInputForm.suburb', required='', placeholder='Enter zip first')
                    .form-group
                      button-load(type="submit", :flag="alert.busy", label="SUBMIT", classes="btn-outline", v-if="!accountInputForm.id")
                      // b-button.btn-clear(@click="deleteAccount()") Delete Account
</template>

<script>
// import { mapActions, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { apiService, userService } from '@/services';
import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      accountInputForm: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        company_name: '',
      },
      addressInputForm: {
        line_1: '',
        line_2: '',
        city: '',
        zip: '',
        suburb: '',
      },
      provinces: ['Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo', 'Mpumalanga', 'Northern Cape', 'North West', 'Western Cape'],
      addresses: [],
    };
  },
  computed: {
    suburbs() {
      const validAddresses = this.addresses.filter(address => address.POSTCODE === this.addressInputForm.zip);
      const validSuburbs = validAddresses.map(address => address.SUBURB);
      return validSuburbs;
    },
  },
  methods: {
    async onSubmit() {
      try {
        // Add new customer
        this.clear();
        this.busy();
        const customer = await apiService.addCustomer(this.accountInputForm);
        if (customer.id) {
          await userService.updateCustomerAddress({ address: this.addressInputForm, id: customer.id });
          this.success('Customer added');
          router.push({ name: 'Customers' });
        }
      } catch (error) {
        this.error(error);
      }
    },
    preselectSuburb() {
      this.inputForm.suburb = this.suburbs[0];
    },
  },
  async created() {
    try {
      this.loading();
      this.addresses = await apiService.getAddresses();
      if (this.$route.params.customerId) {
        this.accountInputForm = await apiService.getCustomer(this.$route.params.customerId);
        this.addressInputForm = await userService.getCustomerAddress(this.$route.params.customerId);
      }
    } catch (error) {
      this.error(error);
    }
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Customer.vue